import { useAPI } from '@pella/cosmos-react';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../utils/enums';

/**
 * Hook to fetch all available sites from the team member data API.
 * @returns {import('@tanstack/react-query').UseQueryResult} Query result containing the list of all sites.
 */
export const useSites = () => {
  const { api, apiReady } = useAPI();

  return useQuery({
    queryKey: [QUERY_KEYS.SITES],
    queryFn: () => api.teamMemberData.getAllSites(),
    staleTime: Number.POSITIVE_INFINITY,
    enabled: Boolean(apiReady),
  });
};
